import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { GETPOSTCOMMENTS } from '@pylot-data/hooks/blog/graphql/blogQuery'
import type { RequestInit } from '@vercel/fetch'

export interface IBlogComment {
    addCommentToPost: BlogCommentList
}

export interface IBlogCommentList {
    blogComments: BlogCommentList
}

export interface BlogCommentList {
    total_count: number
    total_pages: number
    comments: Array<BlogCommentDetail>
    items?: Array<BlogCommentDetail>
}

export interface BlogCommentDetail {
    post_id: number
    comment_id: number
    parent_id: number
    customer_id: number
    admin_id?: number
    status: number
    author_type: null
    author_nickname: string
    author_email: string
    text: string
    creation_time: string
    modified_time: string
    publish_time: string
    update_time: string
}

export type blogCommentsVariables = {
    post_id?: string | null
}

export interface BlogListCommentsVariables {
    post_id?: string
}

export type GetBlogComment = IBlogCommentList

async function getBlogComment({
    post_id,
    locale
}: {
    post_id?: string
    fetchOptions?: RequestInit
    locale?: string
}): Promise<GetBlogComment | undefined | null> {
    const blogcommentDataPromise = graphqlFetch<
        BlogListCommentsVariables,
        IBlogCommentList
    >({
        query: GETPOSTCOMMENTS,
        variables: {
            post_id: post_id
        },
        locale
    })

    const [blogcommentData] = await Promise.all([blogcommentDataPromise])
    return blogcommentData.data
}

export default getBlogComment
